/// <reference types="@types/googlemaps" />
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { crop_Datas, FarmerLandModel, SelectedCropModel } from '../../../models/farmer-land.model';
import { FarmerLandDetailService } from '../../../services/farmer-land-detail.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/internal/operators/first';
import { Message, MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { saveAs } from 'file-saver'
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { TreeNode } from 'primeng/api';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'farmer-land-detail',
  templateUrl: './farmer-land-detail.component.html',
  styleUrls: ['./farmer-land-detail.component.scss'],
  providers: [MessageService],
})
export class FarmerLandDetailComponent implements OnInit {
  public farmerLandForm: FormGroup;
  public jamabandiLandForm: FormGroup;
  public jamabandiLandForm2: FormGroup;
  public consentForm: FormGroup;
  uploadedFiles: any[] = [];
  valRadio: boolean;
  valActive: any;
  productDialog: boolean;
  selectedVillage: any;
  selectedCropType: any;
  filteredVillage: any[];
  filteredCorpType: any[];
  lstFarmerLandModel: FarmerLandModel[];
  farmerLandModel: FarmerLandModel;
  selectedFarmerLand: FarmerLandModel[];
  submitted: boolean;
  statuses: any[];
  items: MenuItem[];
  selectedNodes1: any[] = [];
  nodes2: any[];
  selectedCorpModel: crop_Datas;
  selectedCorpModelList: any;
  editFLModel: FarmerLandModel;
  selectedCropNodes: any;
  blockSpace: RegExp = /^[^\s,]([^,]*[^\s,])?$/;
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  location: any;
  innerWidth: number;
  public loading: boolean = false;
  public loading1: boolean = false;
  cropTypeList: any[];
  cropBasedNames: any[];

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }


  villageList = [];

  cropTypeItems = [
    { Name: 'Alabama', Code: '1' },
    { Name: 'Alaska', Code: '2' },
    { Name: 'Arizona', Code: '3' },
  ];
  farmerId: any = null;
  ipAddress: any = '000.000.000';

  public cropMergeList: any;
  public openJamabandiDialog: boolean = false;
  public submittedJambandi: boolean = false;
  public submittedJambandi2: boolean = false;
  public landOwnerDetails: any = [];
  public districtTehsilCode: any = [];
  public selectedLandOwnerDetails: any = [];
  public expandedRows: any = {};
  public expandedRowsLand: any = {};

  public showHiddenButton: boolean = false;
  public landDetailsfromJamabandi: any = [];

  public selectedLandArea: any = [];
  public addedLandDetails: any = [];

  public farmerMobNo: any;
  public maxLandAreaToAddValidation: any = 0;
  public maxLandAreaToAdd: any = 0;

  public isOwnerAlreadyAppLand: boolean = false;
  public fardPath: any = null;
  public landDetailedInfo: any = [];
  public selectedLandDetails: any;
  public finalLandSubmitClicked: boolean = false;

  public request1complete: boolean = false;
  public request2complete: boolean = false;

  public isBighaBiswa: boolean = false;
  public dynamicMaxKanals: number = 0;
  public dynamicMaxMarlas: number = 0;

  constructor(
    private _personalDetalSer: FarmersDetailsService,
    private primengConfig: PrimeNGConfig,
    private service: MessageService,
    private _formBuilder: FormBuilder,
    private flService: FarmerLandDetailService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private productService: BankDetailService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    private vendorService: VendorDashboardService,
    private cryptoJsService: CryptoJsService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    this.farmerMobNo = farmerconfData.get('farmerPh');
    this.farmerId = farmerconfData.get('Farmer_Id_');

    this.getIP();
    this.getCorpTypeByFarmerId(this.farmerId);
    this.innerWidth = window.innerWidth;
    this.items = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.lstFarmerLandModel, 'Farmer Land Detail');
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.lstFarmerLandModel, 'Farmer Land Detail');
        }
      },
    ];

    this.farmerLandForm = this._formBuilder.group({
      totalArea: ['', [Validators.required]],
      morabbaNumber: [, [Validators.required]],
      killaNumber: [, [Validators.required]],
      kanals: ['', Validators.compose([Validators.required, Validators.max(8)])],
      marlas: ['', Validators.compose([Validators.required, Validators.max(20)])],
      village: ['', [Validators.required]],
      latitude: ['', ''],
      longitude: ['', ''],
      cropType: ['', [Validators.required]],
      // crop: ['', [Validators.required]],
      // IsSubsidyAvailabe: ['', [Validators.required]],
      IsSubsidyAvailabe: [''],
      landdoc_Path: ['', [Validators.required]],
      leaseDoc_Path: ['',],
    });

    this.jamabandiLandForm = this._formBuilder.group({
      village: ['', [Validators.required]],
      khewatNo: [, [Validators.required]],
    });

    this.jamabandiLandForm2 = this._formBuilder.group({
      morabbaNumber: ['', [Validators.required]],
      killaNumber: [, [Validators.required]],
      totalKanals: [, [Validators.required]],
      totalMarlas: [, [Validators.required]],
      totalArea: [, [Validators.required]],
      kanals: [0, Validators.compose([Validators.required, (control: AbstractControl) => Validators.max(this.dynamicMaxKanals)(control)])],
      marlas: [0, Validators.compose([Validators.required, (control: AbstractControl) => Validators.max(this.dynamicMaxMarlas)(control)])],
      totalAppliedArea: [0, [Validators.required, Validators.min(0), (control: AbstractControl) => Validators.max(this.maxLandAreaToAddValidation)(control)]],
      cropType: [, [Validators.required]],
    });

    this.consentForm = this._formBuilder.group({
      consent: [false, [Validators.required]]
    });
    // this.f.totalArea.disable();
    this.primengConfig.ripple = true;
    // this.loadData();
    this.getVillageData();
    this.filteredCorpType = [...this.cropTypeItems];
    
    // this.getFarmerId();
    if(this.farmerId) {
      this.loadData();
    }else{
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: "Complete your KYC first." });
    }

  }

  getFarmerId() {
    let mobile = this.farmerMobNo;
    // this.loader.start();
    this.loading = true;
    this.productService.getFarmerIdByMobileNo(mobile).subscribe(resp => {
      // this.loader.close();
      this.loading = false;
      if (resp.statusCode === 200) {
        // this.activityRecordService.activityRecord(mobile, 'Land Details', '', new Date(), 'Success');

        let far = JSON.parse(resp.data);
        if (far.length > 0) {
          this.farmerId = far[0].Farmer_ID;

          this.loadData()
        }
      }
      else {
        // this.activityRecordService.activityRecord(mobile, 'Land Details', '', new Date(), 'Invalid');
      }
    }, err => {
      // this.loader.close();
      this.loading = false;
    })
  }

  loadData() {
    // if (farmerData) {
    // this.loader.start();
    this.loading1 = true;
    this.flService.Get(this.farmerId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading1 = false;
          if (data.Table.length > 0) {
            this.lstFarmerLandModel = data.Table;
          }
        },
        error: () => {
          // this.loader.close();
          this.loading1 = false;
          this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Land Details not loaded.' });

        }
      });
    // }
  }

  get f() {
    return this.farmerLandForm.controls;
  }

  get f1() {
    return this.jamabandiLandForm.controls;
  }

  get f2() {
    return this.jamabandiLandForm2.controls;
  }

  get consentController(){
    return this.consentForm.controls;
  }

  openNew() {
    this.editFLModel = new FarmerLandModel();

    this.f.totalArea.reset();
    this.f.morabbaNumber.reset();
    this.f.killaNumber.reset();
    this.f.kanals.reset();

    this.f.marlas.reset();
    this.f.village.reset();
    this.f.latitude.reset();
    this.f.longitude.reset();
    this.f.cropType.reset();

    this.submitted = false;
    this.productDialog = true;
  }

  clearJamabandiPortalData() {
    this.farmerLandForm.reset();
    this.jamabandiLandForm.reset();
    this.jamabandiLandForm2.reset();
    this.consentForm.reset();
    this.selectedVillage = null;
    this.showHiddenButton = false;
    this.landOwnerDetails = [];
    this.districtTehsilCode = [];
    this.selectedLandOwnerDetails = [];
    this.addedLandDetails = [];
    this.onClickClearDetail();
    this.selectedNodes1 = [];
    this.fardPath = null;
  }

  onClickGetOwnerDetails() {
    this.submittedJambandi = true;

    if (this.jamabandiLandForm.invalid) {
      return;
    }
    
    // const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    // const farmerconfData = new Map(encData);

    // this.farmerId = farmerconfData.get('Farmer_Id_');

    if (this.farmerId == null) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Please complete the farmer details first.' });
      return;
    }

    let mobile = this.farmerMobNo;

    let val = this.jamabandiLandForm.value;
    let reqBody = {
      khewat: encodeURIComponent(val?.khewatNo),
      villageCode: val?.village?.Code,
    }

    // this.getLanOwnerDetails();

    // this.getLandOwnerDetails(reqBody);
    this.getDistrictTehsilCode(reqBody);
  }

  onClickAddLand(){
    this.submittedJambandi2 = true;

    let landDetails = this.jamabandiLandForm.value;
    let row = this.jamabandiLandForm2.value;

    
    if (this.jamabandiLandForm.invalid) {
      return;
    }

    if (this.jamabandiLandForm2.invalid) {
      return;
    }

    if(Number(row.totalAppliedArea) > Number(row.totalArea)){
      this.messageService.add({
        severity: 'error',
        summary: `Total Appied Area(${row.totalAppliedArea}) can not be greater than the Area(${row.totalArea})`,
        detail: 'Error in Applied Area',
      });
      return;
    }

    if (row.cropType?.length > 4) {
      this.messageService.add({
        severity: 'error',
        summary: 'Crop Limit Exceeds',
        detail: 'Maximun 4 crop is allowed',
      });
      return;
    }

    const isExist = this.addedLandDetails.some(val => val?.killano == row?.killaNumber && val?.morbno == row?.morabbaNumber)

    if(isExist){
      this.messageService.add({
        severity: 'error',
        summary: 'Duplicate Value',
        detail: 'Land already Added',
      });
      return;
    }
    // let isDataExist = false;
    // if(this.addedLandDetails.length > 0) {
    //   isDataExist = this.addedLandDetails.some(data => {
    //     data.morbno == row.morabbaNumber && data.killano == row.killaNumber
    //   })
    // }
    // if(isDataExist){
    //   this.messageService.add({
    //     severity: 'info',
    //     summary: 'Record Already Exist',
    //     detail: 'Duplicate Record found for entered Morabba and Killa number',
    //   });
    //   return;
    // }
  

    // const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    // const farmerconfData = new Map(encData);
    // const farmerData = farmerconfData.get('farmerDetails');

    if (this.farmerId == null) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Please complete the farmer details first.' });
      return;
    }
    this.getSelectedCorpType();

    
    // let totalArea = this.selectedLandOwnerDetails[0]?.owner_hissa.toFixed(4);
    // let kanal = this.selectedLandOwnerDetails[0]?.valKanal;
    // let marla = this.selectedLandOwnerDetails[0]?.valMarla;


    this.addedLandDetails.push({
      "totalArea": row?.totalArea,
      "kanal": row?.totalKanals,
      "marla": row?.totalMarlas,

      "appliedKanal": row?.kanals,
      "appliedMarla": row?.marlas ? row?.marlas : 0,
      "appliedArea": row?.totalAppliedArea,
      
      
      "morbno": row?.morabbaNumber,
      "killano": row?.killaNumber,
      "village_Code": landDetails?.village?.Code,
      "crop_Datas": this.selectedCorpModelList,
      "UnitDesc": this.districtTehsilCode[0]?.unitdesc,
      "cropName": [...new Set(row?.cropType.map(item => item.label))].join(", ")
    })


    setTimeout(()=>{
      this.calLandAreaForValidation();
      this.submittedJambandi2 = false;
    }, 100) ;

    this.jamabandiLandForm2.reset();
    this.landDetailsfromJamabandi = [];
    this.selectedNodes1 = [];
  }

  calLandAreaForValidation(){
    this.selectedLandDetails = [];
    let appliedLandArea = 0;
    if(this.addedLandDetails.length > 0) {
      this.addedLandDetails.forEach(val => {
        appliedLandArea = appliedLandArea + parseFloat(val?.appliedArea);
      })
    }

    this.maxLandAreaToAddValidation = this.maxLandAreaToAdd - appliedLandArea;
  }

  onClickGetKhewat() {
    this.submittedJambandi2 = true;

    let val = this.jamabandiLandForm.value;
    let val2 = this.jamabandiLandForm2.value;

    if (this.jamabandiLandForm.invalid) {
      return;
    }

    if (this.jamabandiLandForm2.invalid) {
      return;
    }

    if (val2.cropType?.length > 4) {
      this.messageService.add({
        severity: 'error',
        summary: 'Crop Limit Exceeds',
        detail: 'Maximun 4 crop is allowed',
      });
      return;
    }

    // if (this.selectedCorpModelList > 4) {
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Crop Limit Exceeds',
    //     detail: 'Maximun 4 crop is allowed',
    //   });
    //   return;
    // }

    let districtTehsil = this.districtTehsilCode[0];

    let reqBody = {
      districtCode: districtTehsil?.R_Dis_Code,
      tehsilCode: districtTehsil?.R_Teh_Code,
      nvCode: districtTehsil?.R_Rev_Code,
      must: encodeURIComponent(val2?.morabbaNumber),
      khasra: encodeURIComponent(val2?.killaNumber),
      format: "json"
    }

    // this.getLandDetails();
    this.getLandAreaDetails(reqBody);
  }

  getLandAreaDetails(reqBody) {
    this.loader.start();
    this.vendorService
      .getLandGetAreaByKhasra(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();
          let val = JSON.parse(resp.msg);
          if (val.length > 0) {
            this.landDetailsfromJamabandi = val;
          } else {
            this.landDetailsfromJamabandi = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found corresponding to entered Mobrabba and killa no',
            });
          }
        },
        error: (err) => {
          this.landDetailsfromJamabandi = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  // getLandDetails() {
  //   this.landDetailsfromJamabandi = [
  //     {
  //       "area": "3 Kanal 4 Marla"
  //     }
  //   ]
  // }

  onSelectLandArea() {

  }

  onClickAddDetail() {
    // const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    // const farmerconfData = new Map(encData);
    // let farmerData = farmerconfData.get('farmerDetails');

    // this.farmerId = farmerconfData.get('Farmer_Id_');

    if (this.farmerId == null) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Please complete the farmer details first.' });
      return;
    }
    this.getSelectedCorpType();

    let val = this.jamabandiLandForm2.value;
    let val1 = this.jamabandiLandForm.value;

    let landSize = this.landDetailsfromJamabandi[0].area;

    let kanal: number = parseInt(landSize.split("Kanal")[0].trim(), 10); // Extracts the Kanal value (3)
    let marla: number = parseInt(landSize.split("Kanal")[1].split("Marla")[0].trim(), 10); // Extracts the Marla value (4)

    // let area =

    let tlk: any = 0.00;// sample kanal variable
    let tlm: any = 0.00;// sample marlas variable
    tlk = kanal * 0.125;
    tlm = marla * 0.006249999998;
    let tl = tlk + tlm;
    const totalArea = tl.toFixed(4)

    this.f.totalArea.setValue(Number(totalArea));

    // this.addedLandDetails.push({
    //   morabbaNo: val.morabbaNumber,
    //   killaNo: val.killaNumber,
    //   kanal: kanal,
    //   marla: marla,
    //   area: totalArea,
    //   cropName: [...new Set(val.cropType.map(item => item.label))].join(", ")
    // })

    this.addedLandDetails.push({
      "total_Area": totalArea,
      "morbno": val.morabbaNumber,
      "killano": val.killaNumber,
      "kanal": kanal,
      "marla": marla,
      "village_Code": val1?.village?.Code,
      "crop_Datas": this.selectedCorpModelList,
      "UnitDesc": this.districtTehsilCode[0]?.unitdesc,
      "cropName": [...new Set(val.cropType.map(item => item.label))].join(", ")
    })

    this.jamabandiLandForm2.reset();
    this.landDetailsfromJamabandi = [];
    this.selectedNodes1 = []; 
  }

  deleteLand(val, index) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Do you want to remove land record of Morabba No: ${val?.morbno} and Killa No: ${val?.killano}?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button-text',
      rejectButtonStyleClass: 'p-button-text p-button-text',
      acceptIcon: 'none',
      rejectIcon: 'none',

      accept: () => {
        this.addedLandDetails.splice(index, 1);
        this.calLandAreaForValidation();
        this.jamabandiLandForm2.reset();
      },
      reject: () => {
        // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      },
    });
  }

  onClickClearDetail() {
    this.landDetailsfromJamabandi = [];
    this.jamabandiLandForm2.reset();
    this.selectedLandArea = [];
  }

  toggleRow(rowData: any) {
    if (this.expandedRows[rowData.landDetails]) {
      delete this.expandedRows[rowData.landDetails];
    } else {
      this.expandedRows[rowData.landDetails] = true;
    }
  }

  onRowSelect(val) {
    let farmerDataArr = val.data
    this.selectedLandOwnerDetails = [farmerDataArr];

    this.jamabandiLandForm2.reset();
    this.landDetailsfromJamabandi = [];
    this.addedLandDetails = [];
    if(farmerDataArr?.TotalArea > 0){
      this.maxLandAreaToAddValidation = farmerDataArr?.owner_hissa - farmerDataArr?.TotalArea;
      this.maxLandAreaToAdd = farmerDataArr?.owner_hissa - farmerDataArr?.TotalArea;
    }else{
      this.maxLandAreaToAddValidation = farmerDataArr?.owner_hissa;
      this.maxLandAreaToAdd = farmerDataArr?.owner_hissa;
    }

    // this.calValidationForEstimation(this.selectedFarmerForEstimation);
    // this.calValidationForEstimation(this.selectedFarmerForEstimation);
    // if(!this.chunkIdToGetData){
    //   this.estimationTableData = [];
    // }
  }

  onRowUnselect(val) {
    this.selectedLandOwnerDetails = [];
    this.maxLandAreaToAddValidation = 0;
    // this.calValidationForEstimation(this.selectedFarmerForEstimation);
    // this.estimationTableData = [];
  }

  getDistrictTehsilCode(reqBody) {
    this.loader.start();
    this.vendorService
      .getGeoDetailsByVillCode(reqBody?.villageCode)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();
          if (resp.length > 0) {
            this.districtTehsilCode = resp;
            let reqBody1 = {
              districtCode: resp[0]?.R_Dis_Code,
              tehsilCode: resp[0]?.R_Teh_Code,
              nvCode: resp[0]?.R_Rev_Code,
              khewat: reqBody?.khewat,
              format: "json",
              farmerId: this.farmerId
            }
            this.getLandOwnerDetails(reqBody1);
          } else {
            this.districtTehsilCode = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.districtTehsilCode = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  getLandOwnerDetails(reqBody) {
    this.loader.start();
    this.vendorService
      .getLandOwnersDetail(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          // this.loader.close();

          if (resp?.length > 0) {
            this.showHiddenButton = true;
            this.landOwnerDetails = resp.map(val => ({
              ...val,
              uiqueId: `${val?.Owner_Name}-${val?.Bhag}`
            }));

            this.isOwnerAlreadyAppLand = resp?.some(val => val?.TotalAreaFarmer > 0);

            let reqBody1 = {
              "districtCode": reqBody.districtCode,
              "tehsilCode": reqBody.tehsilCode,
              "nvCode": reqBody?.nvCode,
              "khewat": reqBody?.khewat,
              "format": "json"
            }
            this.getLandGetAreaByKhewat(reqBody)
            this.getKhasraAreaByKhewatNVCode(reqBody1)
          } else {
            this.loader.close();
            this.showHiddenButton = false;
            // this.landOwnerDetails = `Someting went wrong. Please try again. ${resp}`;
            this.landOwnerDetails = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found',
            });
          }
        },
        error: (err) => {
          this.showHiddenButton = false;
          // this.landOwnerDetails = `Someting went wrong. Please try again. ${err}`;
          this.landOwnerDetails = [];
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }


  getKhasraAreaByKhewatNVCode(reqBody) {
    this.loader.start();
    this.vendorService
      .getKhasraAreaKhewatByNVCODE2Khewat(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          if(this.request1complete){
            this.loader.close();
          }

          if (resp?.status == 200 && resp?.msg != 'Someting went wrong') {
            this.showHiddenButton = true;
            
            let landDetails = JSON.parse(resp?.msg);  

            this.landDetailedInfo = landDetails.map(val => ({
              ...val,
              uiqueId: `${val?.khatoni}-${val?.khewat}-${val?.killa}`,
            }));

          } else {
            this.clearJamabandiPortalData();
            this.showHiddenButton = false;
            this.landDetailedInfo = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Data not found. ${resp?.msg}`,
            });
          }
        },
        error: (err) => {
          this.clearJamabandiPortalData();
          this.showHiddenButton = false;
          this.landDetailedInfo = [];
          if(this.request1complete){
            this.loader.close();
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        complete: () => {
          this.request2complete = true;
        }
      });
  }

  getLandGetAreaByKhewat(reqBody) {
    this.loader.start();
    this.vendorService
      .getLandGetAreaByKhewat(reqBody)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          if(this.request2complete){
            this.loader.close();
          }

          if (resp?.status == 200 && resp?.msg != 'Someting went wrong') {
            this.showHiddenButton = true;
            
            const khewatArea = JSON.parse(resp?.msg)[0]?.area;
            const regex = /(\d+)\s*Kanal\s*(\d+)\s*Marla/;
            const values = khewatArea.match(regex);

            const karnal = values[0] ? parseInt(values[1], 10) : 0;
            const marla = values[2] ? parseInt(values[2], 10) : 0;

            const villageConversionFactor = this.districtTehsilCode[0]?.unitdesc.slice(-2);

            const areaType = this.districtTehsilCode[0]?.unitdesc.slice(0, 5).trim();
            // const isBighaBiswa = areaType.startsWith('B') ? true : false;
            this.isBighaBiswa = areaType.startsWith('B') ? true : false;

            let sqYardsConversionF = 0;
            if (villageConversionFactor == 57) {
              sqYardsConversionF = 50.00;
            } else if (villageConversionFactor == 66){
              sqYardsConversionF = 67.20;
            } else if (villageConversionFactor == 99){
              sqYardsConversionF = 151.25;
            }

            this.landOwnerDetails = this.landOwnerDetails.map(val => ({
              ...val,
              khewatArea: khewatArea,
              khewat_area: this.isBighaBiswa ? `${karnal} Bigha ${marla} Biswa` : `${karnal} Kanal ${marla} Marla`,
              valKanal: karnal,
              valMarla: marla,

              // totalArea_InAcres:  ((karnal * 20) + marla)/20*0.125,
              totalArea_InAcres: this.isBighaBiswa ? (Math.round(((karnal * 20) + marla) * sqYardsConversionF / 4840 * 1000) / 1000) : ((karnal * 20) + marla)/20*0.125,
              // owner_hissa: ((karnal * 20) + marla)*((val?.Bhag).split('/').map(Number)[0]/(val?.Bhag).split('/').map(Number)[1])/20*0.125 ? ((karnal * 20) + marla)*((val?.Bhag).split('/').map(Number)[0]/(val?.Bhag).split('/').map(Number)[1])/20*0.125 : 0,
              owner_hissa: this.isBighaBiswa ? Math.round(((val?.Bhag).split('/').map(Number)[0] / (val?.Bhag).split('/').map(Number)[1]) * (((karnal * 20) + marla) * sqYardsConversionF / 4840) * 1000) / 1000 : ((karnal * 20) + marla)*((val?.Bhag).split('/').map(Number)[0]/(val?.Bhag).split('/').map(Number)[1])/20*0.125,
            }));
          } else {
            this.clearJamabandiPortalData();
            this.showHiddenButton = false;
            this.landOwnerDetails = [];

            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: `Data not found. ${resp?.msg}`,
            });
          }
        },
        error: (err) => {
          this.clearJamabandiPortalData();
          this.showHiddenButton = false;
          this.landOwnerDetails = [];
          if(this.request1complete){
            this.loader.close();
          }

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        complete: () => {
          this.request1complete = true;
        }
      });
  }


  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.farmerLandForm.invalid) {
      return;
    }
    // const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    // const farmerconfData = new Map(encData);
    // let farmerData = farmerconfData.get('farmerDetails');

    // let farmerId = farmerconfData.get('Farmer_Id_') as string;

    if (this.farmerId == null) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Please complete the farmer details first.' });
      return;
    }
    this.getSelectedCorpType();
    this.farmerLandModel = new FarmerLandModel();
    this.farmerLandModel.land_ID = 0;
    this.farmerLandModel.farmerID = this.farmerId;
    this.farmerLandModel.total_Area = this.f.totalArea.value;
    this.farmerLandModel.morbno = this.f.morabbaNumber.value;
    this.farmerLandModel.killano = this.f.killaNumber.value;
    this.farmerLandModel.kanal = this.f.kanals.value;
    this.farmerLandModel.marla = this.f.marlas.value;
    this.farmerLandModel.village_Code = this.f.village.value.Code;
    this.farmerLandModel.lat = this.f.latitude.value ? this.f.latitude.value : 0;
    this.farmerLandModel.long = this.f.longitude.value ? this.f.longitude.value : 0;
    // this.farmerLandModel.is_Available_Lease = this.valRadio;
    this.farmerLandModel.is_Available_Lease = false;
    this.farmerLandModel.landdoc_Path = this.f.landdoc_Path.value;
    this.farmerLandModel.lease_Agrement_Doc = this.valRadio ? this.f.leaseDoc_Path.value : '';
    this.farmerLandModel.user_ID = this.farmerId;
    this.farmerLandModel.network_ID = this.ipAddress;
    this.farmerLandModel.terminal_ID = this.ipAddress;
    this.farmerLandModel.active = "1";
    this.farmerLandModel.crop_Datas = this.selectedCorpModelList;

    let mobile = this.farmerMobNo;

    if (this.selectedCorpModelList > 4) {
      this.messageService.add({
        severity: 'error',
        summary: 'Crop Limit Exceeds',
        detail: 'Maximun 4 crop is allowed',
      });
      return;
    }

    if (this.editFLModel.Land_ID > 0) {
      this.farmerLandModel.land_ID = this.editFLModel.Land_ID;
      this.loader.start();
      // this.loading = true;
      this.flService.UpdateLandDetails(this.farmerLandModel)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.loader.close();
            // this.loading = false;
            this.loadData();
            // this.activityRecordService.activityRecord(mobile, 'Land Details Updated', '', new Date(), data, this.farmerLandModel);
            if (data == 'Success') {
              this.service.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
            }
            else {
              this.service.add({ severity: 'info', summary: 'Info Message', detail: JSON.stringify(data) });
            }
            this.productDialog = false;
            this.farmerLandForm.reset()
          },
          error: (err) => {
            this.loader.close();
            // this.loading = false;
            // this.activityRecordService.activityRecord(mobile, 'Land Details Updated', '', new Date(), err, this.farmerLandModel);

            this.service.add({ severity: 'error', summary: 'Error Message', detail: err });
          }
        });
    }
    else {
      this.loader.start();
      // this.loading = true;
      this.flService.InsertLandDetails(this.farmerLandModel)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.loader.close();
            // this.loading = false;
            this.loadData();
            this.activityRecordService.activityRecord(mobile, 'Land Details Inserted', '', new Date(), data, this.farmerLandModel);
            if (data == 'Success') {
              this.service.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
            }
            else {
              this.service.add({ severity: 'info', summary: 'Info Message', detail: JSON.stringify(data) });
            }
            this.productDialog = false;
          },
          error: (err) => {
            // this.loader.close();
            this.loading = false;
            this.activityRecordService.activityRecord(mobile, 'Land Details Inserted', '', new Date(), err, this.farmerLandModel);

            this.service.add({ severity: 'error', summary: 'Error Message', detail: err });
          }
        });
    }

  }

  getSelectedCorpType() {
    this.selectedCorpModel = new crop_Datas();
    this.selectedCorpModelList = [];
    let selectedLabels = [];

    this.selectedCorpModelList = this.selectedNodes1.map(val => ({
      type_of_crop_ID: val.parentData,
      crop_ID: val.data
    }))

    // for (let result of this.selectedNodes1) {
    //   if (result.parent) {
    //     if(selectedLabels.includes(result.label)){
    //       break;
    //     }
    //     let body = {
    //       crop_ID : result.data,
    //       type_of_crop_ID: result.parent?.data
    //     }
    //     this.selectedCorpModelList.push(body);
    //     selectedLabels.push(result.label);
    //   }else if(result.children){
    //     result.children.forEach(child => {
    //       if(selectedLabels.includes(child.label)){
    //         return;
    //       }
    //       let body = {
    //         crop_ID : child.data,
    //         type_of_crop_ID: (child.parent?.data) ? child.parent?.data : result.data
    //       }

    //       this.selectedCorpModelList.push(body);
    //       selectedLabels.push(child.label);
    //     })
    //   }
    // }
  }

  hideDialog() {
    this.selectedNodes1 = []
    this.selectedVillage = {}
    this.selectedNodes1 = [];
    this.productDialog = false;
    this.submitted = false;
    this.farmerLandForm.reset()
    this.cropBasedNames = [];
  }

  public setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      });
    }
  }


  showPosition(position) {
    let geocoder = new google.maps.Geocoder;
    let latlng = { lat: position.coords.latitude, lng: position.coords.longitude };
    this.f.latitude.setValue(position.coords.latitude);
    this.f.longitude.setValue(position.coords.longitude);
  }

  // getCorpType() {
  //   this.flService.GetCorpType()
  //     .pipe(first())
  //     .subscribe({
  //       next: (files) => {
  //         this.nodes2 = files
  //         this.cropTypeList = files;

  //         let arrayCrop = [];
  //         let cropMerge = files.map((parent) => {
  //           arrayCrop.push(
  //             parent['children'].map((child) => ({
  //               ...child,
  //               parentData: parent.data,
  //               parentLabel: parent.label
  //             }))
  //           );
  //         });

  //         this.cropMergeList = [].concat(...arrayCrop);
  //       },
  //       error: () => {
  //         this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Corp Type Details not loaded.' });

  //       }
  //     });
  // }

  getCorpTypeByFarmerId(farmerId) {
    let reqBody = {
      farmerId: this.farmerId
    }
    
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.flService.getCropMasterNew(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (files) => {
          if(files){
            this.nodes2 = files
            this.cropTypeList = files;

            let arrayCrop = [];
            let cropMerge = files.map((parent) => {
              arrayCrop.push(
                parent['children'].map((child) => ({
                  ...child,
                  parentData: parent.data,
                  parentLabel: parent.label
                }))
              );
            });

            this.cropMergeList = [].concat(...arrayCrop);
          }
          
        },
        error: () => {
          this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Corp Type Details not loaded.' });

        }
      });
  }

  editProduct(bank: any) {
    this.editFLModel = new FarmerLandModel();

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let farmerData = farmerconfData.get('farmerDetails');

    let flModel = { ...bank };
    this.f.totalArea.setValue(flModel.Total_Area);
    this.f.morabbaNumber.setValue(flModel.Morabba_No);
    this.f.killaNumber.setValue(flModel.Killa_No);
    this.f.kanals.setValue(flModel.Kanals);

    this.f.marlas.setValue(flModel.Marlas);

    this.f.latitude.setValue(flModel.Lat);
    this.f.longitude.setValue(flModel.Long);
    this.valRadio = flModel.IS_Avalibe_for_Lease;
    this.f.cropType.setValue(flModel.Crop_Type_ID);
    this.f.landdoc_Path.setValue(flModel.Land_Doc);
    this.editFLModel = flModel;
    this.productDialog = true;

    let village = this.villageList.filter(val => val.Code === flModel.Village_Code)[0]
    this.f.village.setValue(village.Name);
    this.selectedVillage = village;
    if (parseInt(this.f.kanals.value) >= 8) {
      this.f.marlas.disable();
    }
  }

  filterCorpType(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.cropTypeItems.length; i++) {
      const corpType = this.cropTypeItems[i];
      if (corpType.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(corpType);
      }
    }

    this.filteredCorpType = filtered;
  }

  filterVillage(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }

    this.filteredVillage = filtered;
  }

  deleteProduct(bank: any) {
    let mobile = this.farmerMobNo;

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    const userID_ = farmerConfData.get('userID');

    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const userId = loginDetails.get('User_name_while_login') ? loginDetails.get('User_name_while_login') : null;

    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.farmerLandModel = new FarmerLandModel();
        this.farmerLandModel.farmerID = this.farmerId;
        this.farmerLandModel.landID = bank.Land_ID;
        this.farmerLandModel.user_ID = userId ? String(userId) : String(userID_),
        this.farmerLandModel.network_ID = this.ipAddress;
        this.farmerLandModel.terminal_ID = this.ipAddress;
        // this.loader.start();
        this.loading = true;
        this.flService.DeleteLandDetails(this.farmerLandModel)
          .pipe(first())
          .subscribe({
            next: (data) => {
              // this.loader.close();
              this.loading = false;
              this.loadData();
              if (data == "Deleted Successfully!") {
                this.service.add({ severity: 'success', summary: 'Success Message', detail: JSON.stringify(data) });
              }
              else {
                this.service.add({ severity: 'info', summary: 'INfo Message', detail: JSON.stringify(data) });
              }

              this.activityRecordService.activityRecord(mobile, 'Land Details Delete', '', new Date(), data, this.farmerLandModel);
            },
            error: (err) => {
              // this.loader.close();
              this.loading = false;
              this.service.add({ severity: 'error', summary: 'Error Message', detail: err });
              this.activityRecordService.activityRecord(mobile, 'Land Details Delete', '', new Date(), err, this.farmerLandModel);

            }
          });
      }
    });
  }

  onKanalsChange() {
    let tlk: any = 0.00;// sample kanal variable
    let tlm: any = 0.00;// sample marlas variable
    this.f2.marlas.setValue(0);
    if (this.f2.kanals.value) {
      if (parseInt(this.f2.kanals.value) >= 8) {
        this.f2.marlas.setValue(0);
        this.f2.marlas.disable();
        // tlm = 1;
      }
      else {
        this.f2.marlas.enable();
      }
      tlk = parseInt(this.f2.kanals.value) * 0.125;
    }
    if (this.f2.marlas.value) {
      tlm = parseInt(this.f2.marlas.value) * 0.006249999998;
    }

    let tl = tlk + tlm;
    const totalArea = tl.toFixed(4)
    this.f2.totalAppliedArea.setValue(Number(totalArea));
  }

  onKMBBChangeNew(){
    if(this.isBighaBiswa){
      const villageConversionFactor = this.districtTehsilCode[0]?.unitdesc.slice(-2);
      let conversionFactor = 0;
      if (villageConversionFactor == '57') {
        conversionFactor = 50.00;
      } else if (villageConversionFactor == '66') {
        conversionFactor = 67.20;
      } else if (villageConversionFactor == '99') {
        conversionFactor = 151.25;
      }
      let bigha: number = parseInt(this.f2.kanals.value) ? parseInt(this.f2.kanals.value) : 0;
      let biswa: number = parseInt(this.f2.marlas.value) ? parseInt(this.f2.marlas.value) : 0;

      const totalArea = ((bigha * 20) + biswa)*conversionFactor / 4840;
      this.f2.totalAppliedArea.setValue(totalArea.toFixed(4));
    }else{
      let kanal: number = parseInt(this.f2.kanals.value);
      let marla: number = parseInt(this.f2.marlas.value);

      const totalArea = ((kanal * 20) + marla) / 20 * 0.125;
      this.f2.totalAppliedArea.setValue(totalArea.toFixed(4));
    }
  }

  onMarlasChange() {
    let tlk: any = 0.00;
    let tlm: any = 0.00;
    if (this.f2.kanals.value != undefined || this.f2.kanals.value != '') {
      tlk = (this.f2.kanals.value ? parseInt(this.f2.kanals.value) : 0) * 0.125;
    }
    if (this.f2.marlas.value != undefined || this.f2.marlas.value != '') {
      tlm = (this.f2.marlas.value ? parseInt(this.f2.marlas.value) : 0) * 0.006249999998;
    }
    // if (this.f.marlas.value > 19){
    //   this.f.marlas.setValue()
    // }

    let tl = tlk + tlm;
    this.f2.totalAppliedArea.setValue(parseFloat(tl).toFixed(2));
  }

  getVillageData() {
    // this.loader.start();
    this.loading = true;
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      // this.loader.close();
      this.loading = false;
      this.villageList = res;
      this.filteredVillage = [...this.villageList]
      if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
    })
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Land Id': d.Land_ID,
          'Owner Name': d.OwnerName,
          'Khewat': d.Khewat,
          'Bhag': d.Bhag,
          'Total Area': d.Total_Area,
          'Morabba No': d.Morabba_No,
          'Killa No': d.Killa_No,
          'Kanals': d.Kanals,
          "Marlas": d.Marlas,
          "Year": d.Year,
          
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'Land_ID', header: 'Land ID' },
      { field: 'OwnerName', header: 'Owner Name' },
      { field: 'Khewat', header: 'Khewat' },
      { field: 'Bhag', header: 'Bhag' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'Morabba_No', header: 'Morabba Number' },
      { field: 'Killa_No', header: 'Killa Number' },
      { field: 'Kanals', header: 'Kanals' },
      { field: 'Marlas', header: 'Marlas' },
      { field: 'Year', header: 'Year' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }

  onUploadFard(event, formcontrol, uploadElement) {
    this.loader.start();
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    this._personalDetalSer.uploadFile(data, this.farmerMobNo, formcontrol).subscribe((resp: any) => {
      this.loader.close();
      if (resp.statusCode == 200) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'File Uploaded with Auto Mode',
        });
        this.fardPath = resp.data;
        // this.farmerLandForm.patchValue({ [formcontrol]: resp.data });
      }
      else {
        this.messageService.add({
          severity: 'info',
          summary: 'Info',
          detail: 'File Not Uploaded. Please try again.',
        });
      }
    }, err => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `File Not Uploaded. ${err}.`,
      });
      this.loader.close();
    })
    uploadElement.clear();
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = ipAddress;
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        farmerConfData.set('ipAddress', this.ipAddress)

        const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }
  
  onCropSelect(val) {
    if (val.value.length > 4) {
      this.messageService.add({
        severity: 'info',
        summary: 'Crop Limit Exceeds',
        detail: 'Maximun 4 crop is allowed',
      });
    }
  }

  onClickJamabandi() {
    if (this.farmerId == null) {
      this.service.add({ severity: 'warn', summary: 'Info Message', detail: 'OOPs! KYC not done. Please complete your KYC.' });
      return;
    }
    this.openJamabandiDialog = true;
  }

  hideDialogJamaBandi() {
    this.openJamabandiDialog = false;
    this.clearJamabandiPortalData();
  }

  onFinalSubmitClick() {
    this.finalLandSubmitClicked = true;
    // const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    // const farmerconfData = new Map(encData);
    // const farmerData = farmerconfData.get('farmerDetails');

    // let farmerId = farmerconfData.get('Farmer_Id_') as string;

    if (this.farmerId == null) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Please complete the farmer details first.' });
      return;
    }

    if (this.consentForm.value.consent != true) {
      this.service.add({ severity: 'info', summary: 'Info Message', detail: 'Please click on consent checkbox.' });
      return;
    }

    // if (this.fardPath == null || this.fardPath == '') {
    //   this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Please upload fard document.' });
    //   return;
    // }

    let reqBody = this.addedLandDetails.map((val) => ({
      "UnitDesc": val?.UnitDesc,
      "total_Area": val?.appliedArea,
      "morbno": val?.morbno,
      "killano": val?.killano,
      "TotalkanalinKhasra": val?.kanal,
      "kanal": val?.appliedKanal,
      "TotalmarlainKhasra": val?.marla,
      "marla": val?.appliedMarla,
      "village_Code": val?.village_Code,
      "crop_Datas": val?.crop_Datas,
      "land_ID": 0,
      "farmerID": this.farmerId,
      "is_Available_Lease": false,
      "landdoc_Path": this.fardPath ? this.fardPath : '',
      "active": "1",
      "lat": 0,
      "long": 0,
      "user_ID": this.farmerId,
      "lease_Agrement_Doc": "",
      "network_ID": this.ipAddress,
      "terminal_ID": this.ipAddress,
      "ownerName": this.selectedLandOwnerDetails[0]?.Owner_Name,
      "bhag": this.selectedLandOwnerDetails[0]?.Bhag,
      "khewat": this.selectedLandOwnerDetails[0]?.Khewat,
      "year": this.selectedLandOwnerDetails[0]?.Year,
      "khewatArea":  this.selectedLandOwnerDetails[0]?.khewat_area,
      "ownerHissa":  this.selectedLandOwnerDetails[0]?.owner_hissa,
    }));

    
    this.submitJamabandiLandData(reqBody);
  }

  submitJamabandiLandData(reqBody) {
    let mobile = this.farmerMobNo;


    this.loader.start();

    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.flService.insertJamabandi(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          
          this.activityRecordService.activityRecord(mobile, 'Land Details(JamaBandi) Inserted', '', new Date(), data, JSON.stringify(reqBody));
          if (data == 'All entries inserted successfully!') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: JSON.stringify(data),
            });
            this.productDialog = false;
            this.loadData();
            this.hideDialogJamaBandi();
          }
          else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: JSON.stringify(data),
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(mobile, 'Land Details(JamaBandi) Inserted', '', new Date(), err, JSON.stringify(reqBody));

          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: JSON.stringify(err),
          });
        }
      });
  }

  onRowSelectLand(val){
    // this.selectedLandDetails = val.data;
    let selectedLandDetails = this.landDetailedInfo.filter(land => land.uiqueId == val.data.uiqueId);

    if(selectedLandDetails.length == 1){
      this.selectedLandDetails = selectedLandDetails[0];
    }else if(selectedLandDetails.length > 1){
      // Sum knl and mrl values from all selectedLandDetails
      const totalKnls = selectedLandDetails.reduce((sum, land) => sum + (parseInt(land.knl) || 0), 0);
      const totalMrls = selectedLandDetails.reduce((sum, land) => sum + (parseInt(land.mrl) || 0), 0);

      // Use the first land object as a base, and override knl/mrl with the summed values
      this.selectedLandDetails = {
        ...selectedLandDetails[0],
        knl: totalKnls,
        mrl: totalMrls,
      };
    }

    this.jamabandiLandForm2.reset();
    this.consentForm.reset();
    this.f2.morabbaNumber.setValue(this.selectedLandDetails.must);
    this.f2.killaNumber.setValue(this.selectedLandDetails.killa);
    this.f2.totalKanals.setValue(this.selectedLandDetails.knl);
    this.f2.totalMarlas.setValue(this.selectedLandDetails.mrl);

    // let tlk: any = 0.00;
    // let tlm: any = 0.00;
    // if (this.f2.totalKanals.value) {
    //   tlk = parseInt(this.f2.totalKanals.value) * 0.125;
    // }
    // if (this.f2.totalMarlas.value) {
    //   tlm = parseInt(this.f2.totalMarlas.value) * 0.006249999998;
    // }
    // let tl = tlk + tlm;
    // const totalArea = tl.toFixed(4)
    // this.f2.totalArea.setValue(Number(totalArea));

    this.dynamicMaxKanals = this.selectedLandDetails.knl;
    // this.dynamicMaxMarlas = this.selectedLandDetails.mrl;
    this.dynamicMaxMarlas = 20;


    if(this.isBighaBiswa){
      const villageConversionFactor = this.districtTehsilCode[0]?.unitdesc.slice(-2);
      let conversionFactor = 0;
      if (villageConversionFactor == '57') {
        conversionFactor = 50.00;
      } else if (villageConversionFactor == '66') {
        conversionFactor = 67.20;
      } else if (villageConversionFactor == '99') {
        conversionFactor = 151.25;
      }
      let bigha: number = parseInt(this.selectedLandDetails.knl);
      let biswa: number = parseInt(this.selectedLandDetails.mrl);

      const totalArea = ((bigha * 20) + biswa)*conversionFactor / 4840;
      this.f2.totalArea.setValue(totalArea.toFixed(4));
    }else{
      let kanal: number = parseInt(this.selectedLandDetails.knl);
      let marla: number = parseInt(this.selectedLandDetails.mrl);

      const totalArea = ((kanal * 20) + marla) / 20 * 0.125;
      this.f2.totalArea.setValue(totalArea.toFixed(4));
    }
  }


  onRowUnselectLand(val){
    this.jamabandiLandForm2.reset();
    this.consentForm.reset();
    this.dynamicMaxMarlas = 0;
    this.dynamicMaxKanals = 0;

    this.selectedLandDetails = [];
  }

  toggleRowLand(rowData: any) {
    // if (this.expandedRowsLand[rowData.landDetails]) {
    //   delete this.expandedRowsLand[rowData.landDetails];
    // } else {
    //   this.expandedRowsLand[rowData.landDetails] = true;
    // }
  }

  onClickResetLandDetails(){
    this.jamabandiLandForm2.reset();
    this.consentForm.reset();
    this.selectedLandDetails = [];
  }
}
